import { useTheme } from '@mui/material/styles';

const defaultColors = [
  '#3B8C43', // Dark Green
  '#3241FF', // Blue
  '#F24C40', // Orange
  '#E091FF', // Lavender
  '#6C32FF', // Purple

  '#7AFF8A', // MerQube Green
  '#002981', // Dark Blue
  '#ED9726', // Tangerine
  '#FFFF4F', // Yellow
  '#D7FFDC', // Mint

  '#3B94FF', // Light Blue
  '#212421', // Black
  '#767776', // Dark Grey
  '#B1B2B1', // Grey
  '#F1F2F2', // Light Grey
];

const useChartColors = () => {
  const theme = useTheme();
  const colors = [...defaultColors];

  if (theme.palette.mode === 'dark') {
    colors[11] = '#FFFFFF';
    colors[12] = '#EAEAEA';
    colors[13] = '#D3B683';
    colors[14] = '#B1B2B1';
  }

  return {
    colors: colors,
    defaultColor: theme.palette.primary.main,
  };
};

export default useChartColors;
